The preference for the types of work for a position.

This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be an empty list.

Currently, four codes are defined:

- `Casual` indicates a casual position.
- `ContractTemp` indicates a fixed-length contract position.
- `FullTime` indicates a full-time position.
- `PartTime` indicates a part-time position.
